import { double } from '../check/arbitrary/FloatingPointArbitrary.js';
import { array } from './array.js';
export function float64Array(constraints = {}) {
    return array(double(Object.assign(Object.assign({}, constraints), { next: true })), constraints).map((data) => Float64Array.from(data));
}
